import type { LevelOneId, LevelOneItem } from './types';

/**
 * Level 1 in its fixed order: Home · My rewards · Recognize · Manage · Insights · Settings.
 * APP-234 (Tom, 2026-10-28): Manage, the work a person does for others, after the menus everyone
 * has. APP-236 (Tom, 2026-10-29): the Executive pages are Manage's Executive group.
 */
export const LEVEL_ONE: readonly LevelOneItem[] = [
  { id: 'home', label: 'Home', href: '/' },
  { id: 'my-rewards', label: 'My rewards', href: '/my-rewards' },
  { id: 'recognize', label: 'Recognize', href: '/recognize' },
  { id: 'manage', label: 'Manage', href: '/manage' },
  { id: 'insights', label: 'Insights', href: '/insights' },
  { id: 'settings', label: 'Settings', href: '/settings' },
];

/**
 * The items a person sees: only the ones passed in (hidden, not greyed), always in the fixed
 * order, whatever order they were passed in. Unknown or repeated ids are ignored.
 */
export function visibleLevelOne(
  allowed: readonly LevelOneId[],
  hrefs: Partial<Record<LevelOneId, string>> = {},
): LevelOneItem[] {
  const wanted = new Set(allowed);
  return LEVEL_ONE.filter((item) => wanted.has(item.id)).map((item) => ({
    ...item,
    href: hrefs[item.id] ?? item.href,
  }));
}

/** Initials for the avatar circle: "Graham Whitlock" → "GW" (APP-190: one rule everywhere). */
export { initialsOf } from '@myrewards/domain';
